import request from './requestUtils'

interface RebucketOptimizelyResponse {
  optimizelyExperiments: Record<string, App.OptimizelyExperimentDetails | undefined>
  optimizelyFeatureFlags: App.OptimizelyFeatureFlag
  resolvedTrackingId: string
}

/**
 * Re-bucket Optimizely experiments after user login
 *
 * Calls the server-side re-bucketing endpoint which re-runs Optimizely
 * bucketing with the authenticated user's stitched seed ID.
 *
 * The server derives the feature flag context from the request (same logic as SSR)
 * to ensure consistency.
 *
 * Note: This endpoint is on the SSR server (customer portal), not the API backend.
 * We use an empty string as endpointOverride to make the request relative to the current domain.
 *
 * @returns Updated experiment decisions and resolved tracking ID
 */
export async function rebucketOptimizely(): Promise<RebucketOptimizelyResponse | undefined> {
  return await request.post<RebucketOptimizelyResponse, unknown>('/api/optimizely/rebucket', undefined, {}, '')
}
